import _isPlainObject from 'lodash/isPlainObject';
import { UNKNOWN_ERROR, NETWORK_ERROR, TIMEOUT_ERROR, CONNECTION_ERROR } from './_constants';
export var normalizeError = function normalizeError(error) {
  var httpCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!_isPlainObject(error)) {
    error = {};
  }

  return Object.assign({}, {
    code: UNKNOWN_ERROR
  }, error, {
    httpCode: httpCode
  });
};
export var getRequestError = function getRequestError(err) {
  var code = UNKNOWN_ERROR;

  if (err.message === 'Network Error') {
    code = NETWORK_ERROR;
  } else if (err.code) {
    var _isErrorType = function _isErrorType(values) {
      return values.indexOf(err.code) !== -1;
    };

    if (_isErrorType(['ECONNABORTED'])) {
      code = TIMEOUT_ERROR;
    } else if (_isErrorType(['ENOTFOUND', 'ECONNREFUSED', 'ECONNRESET'])) {
      code = CONNECTION_ERROR;
    }
  }

  return normalizeError({
    code: code
  });
};
export var makeTrashable = function makeTrashable(promise, cancelCb) {
  var abort = function abort() {};

  var wrapperPromise = new Promise(function (resolve, reject) {
    abort = function abort() {
      if (cancelCb) {
        cancelCb();
      }

      resolve = null;
      reject = null;
    };

    promise.then(function (val) {
      if (resolve) {
        resolve(val);
      }
    }, function (error) {
      if (reject) {
        reject(error);
      }
    });
  });
  wrapperPromise.abort = abort;
  return wrapperPromise;
};
export var conveyTrashable = function conveyTrashable(requestPromise, processor) {
  var promise = processor(requestPromise);

  promise.abort = function () {
    requestPromise.abort();
  };

  return promise;
};